/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React from 'react'

export default function StatusIndicator({ status, setmodalpopup, item, testid, hasPrivilege }) {
    const statusObj = {
        true: {
            img: "Success.svg",
            text: "Active",
            class: "flex justify-start space-x-3",
        },
        false: {
            img: "close.png",
            text: "Inactive",
            class: "flex justify-start",
        },
    };

    return (
        <div className={`${statusObj[status].class} z-0 relative`}>
            <div className="flex space-x-1 items-center">
                <img src={`/assets/images/${statusObj[status].img}`} alt="" className={`cursor-default`}/>
                <h1 key="status" className="text-sm font-normal text-[#1F1F1F]">
                    {statusObj[status].text}
                </h1>
            </div>
            {hasPrivilege &&
                < div class="status custom-toggle flex items-center" onClick={() => {
                    if (hasPrivilege) {
                        setmodalpopup(item)
                    }
                }
                }>
                    <label class="switch" style={{ marginLeft: "10px" }}>
                        <input type="checkbox" id="clock_in_out" checked={status === 'true' ? true : false} />
                        <span data-testid={testid} class={`slider round ${hasPrivilege ? 'cursor-pointer' : 'cursor-not-allowed'}`}></span>
                    </label>
                </div>}
        </div>
    )
}
